import snakecaseKeys from 'snakecase-keys';
import { InjectiveTokenFactoryV1Beta1Tx } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgChangeAdmin extends MsgBase {
    static fromJSON(params) {
        return new MsgChangeAdmin(params);
    }
    toProto() {
        const { params } = this;
        const message = InjectiveTokenFactoryV1Beta1Tx.MsgChangeAdmin.create();
        message.sender = params.sender;
        message.denom = params.denom;
        message.newAdmin = params.newAdmin;
        return InjectiveTokenFactoryV1Beta1Tx.MsgChangeAdmin.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/injective.tokenfactory.v1beta1.MsgChangeAdmin',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
        };
        return {
            type: 'injective/tokenfactory/change-admin',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/injective.tokenfactory.v1beta1.MsgChangeAdmin',
            ...value,
        };
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/injective.tokenfactory.v1beta1.MsgChangeAdmin',
            message: proto,
        };
    }
    toBinary() {
        return InjectiveTokenFactoryV1Beta1Tx.MsgChangeAdmin.encode(this.toProto()).finish();
    }
}
